module.exports = __webpack_public_path__ + "img/menu-item-1.86d877b4.svg";